import React from 'react';
import { useNavigate } from 'react-router-dom';
import TOKENS from '../data/tokens';
import { ArrowLeft } from 'lucide-react';

const PrivacyPage = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      background: TOKENS.colors.heroBackground,
      display: 'flex',
      flexDirection: 'column',
    }}>
      {/* Header */}
      <header style={{
        background: '#000000',
        padding: '20px 24px',
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
      }}>
        <button
          onClick={() => navigate('/')}
          style={{
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            color: TOKENS.colors.textGold,
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontFamily: TOKENS.fonts.elegant,
            fontSize: '14px',
            padding: '8px 12px',
            borderRadius: '8px',
            transition: 'all 0.25s ease',
          }}
          onMouseEnter={e => e.currentTarget.style.background = 'rgba(212, 168, 83, 0.1)'}
          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
        >
          <ArrowLeft size={18} />
          Back to Home
        </button>
      </header>

      {/* Main Content */}
      <main style={{
        flex: 1,
        maxWidth: '800px',
        margin: '0 auto',
        padding: '48px 24px',
        width: '100%',
      }}>
        {/* Title */}
        <h1 style={{
          fontFamily: TOKENS.fonts.heading,
          fontSize: '36px',
          fontWeight: 500,
          color: TOKENS.colors.textBlack,
          marginBottom: '8px',
          textAlign: 'center',
        }}>
          Privacy Policy
        </h1>
        <p style={{
          fontFamily: TOKENS.fonts.elegant,
          fontSize: '16px',
          color: TOKENS.colors.textGold,
          textAlign: 'center',
          marginBottom: '40px',
          letterSpacing: '2px',
          textTransform: 'uppercase',
        }}>
          SMS & Contact Data
        </p>

        {/* Content Card */}
        <div style={{
          background: '#FFFFFF',
          borderRadius: TOKENS.borderRadius.large,
          padding: '40px',
          boxShadow: TOKENS.shadows.card,
        }}>
          <div style={{
            fontFamily: TOKENS.fonts.body,
            fontSize: '15px',
            lineHeight: 1.8,
            color: TOKENS.colors.textGrey,
          }}>
            <p style={{ marginBottom: '20px' }}>
              We respect your privacy. When you submit your information through this website, you consent to being contacted by us via phone, email, or SMS for event updates, invitations, confirmations, reminders, and related communications.
            </p>

            <p style={{ marginBottom: '20px' }}>
              We collect personal details such as your name, phone number, email address, and RSVP information solely for event coordination and guest management.
            </p>

            <p style={{ marginBottom: '20px' }}>
              Your information will never be sold, rented, or shared with third parties for marketing or promotional purposes.
            </p>

            <p style={{ marginBottom: '20px' }}>
              Message frequency varies depending on your interaction with the event. Message and data rates may apply.
            </p>

            <p style={{ marginBottom: '20px' }}>
              You may opt out of SMS communications at any time by replying <strong style={{ color: TOKENS.colors.textGold }}>STOP</strong>. For assistance, reply <strong style={{ color: TOKENS.colors.textGold }}>HELP</strong> or contact us through the website.
            </p>

            <p style={{ marginBottom: '0' }}>
              We use reasonable administrative and technical safeguards to protect your information.
            </p>
          </div>
        </div>

        {/* Return Button */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '40px',
        }}>
          <button
            onClick={() => navigate('/')}
            style={{
              background: TOKENS.colors.buttonGold,
              color: '#FFFFFF',
              border: 'none',
              borderRadius: TOKENS.borderRadius.medium,
              padding: '14px 48px',
              fontSize: '15px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.25s ease',
              boxShadow: TOKENS.shadows.button,
              fontFamily: TOKENS.fonts.body,
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(212, 168, 83, 0.4)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = TOKENS.shadows.button;
            }}
          >
            Return to Home
          </button>
        </div>
      </main>

      {/* Footer */}
      <footer style={{
        background: '#000000',
        padding: '24px',
        textAlign: 'center',
      }}>
        <p style={{
          fontFamily: TOKENS.fonts.heading,
          fontSize: '11px',
          color: '#6A6050',
          letterSpacing: '0.5px',
          margin: 0,
        }}>
          © 2026 80 YEARS of CONNECTION. All rights reserved.
        </p>
      </footer>
    </div>
  );
};

export default PrivacyPage;
